import React from 'react'

// Material-UI
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import { IoIosList, IoMdCheckboxOutline } from 'react-icons/io'
import { useErrorSnackBarContext } from '../../ErrorSnackBar/ErrorSnackBarContext'
import Interceptor from '../../../../Services/serviceBase.interceptor'
import './PetsItem.scss'

function PetsItem({ petsEntity }) {
  Interceptor.interceptor(useErrorSnackBarContext().errorSnackBarActions)

  const renderCagedSwitch = (caged) => {
    switch (caged) {
      case 1:
        return 'Yes';
      case 2:
        return 'No';
      default:
        return 'Sometimes';
    }
  }


  return (
    <div className="App PetsItem">
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid size={12}>
          </Grid>
          <Grid size={12}>
            <form noValidate autoComplete="off">
              <Grid container>
                <Grid size={12} className="container-field">
                  {petsEntity.type ?
                    <Grid>
                      <label className="main-title-label">Type:</label>
                      <Grid className="container-field">
                        {<IoIosList />}<label> {petsEntity.type} </label>
                      </Grid>
                    </Grid> : null}

                  {petsEntity.name ?
                    <Grid>
                      <label className="main-title-label">Name:</label>
                      <Grid className="container-field">
                        {<IoIosList />}<label>  {petsEntity.name} </label>
                      </Grid>
                    </Grid> : null}

                  {petsEntity.dangerousStranger !== null ?
                    <Grid>
                      <label className="main-title-label">Dangerous to strangers:</label>
                      <Grid className="container-field">
                        {<IoMdCheckboxOutline />}<label>{petsEntity.dangerousStranger === false ? 'No' : 'Yes'} </label>
                      </Grid>
                    </Grid> : null}

                  {petsEntity.serviceAnimal !== null ?
                    <Grid>
                      <label className="main-title-label">Service Animal:</label>
                      <Grid className="container-field">
                        {<IoMdCheckboxOutline />}<label>{petsEntity.serviceAnimal === false ? 'No' : 'Yes'} </label>
                      </Grid>
                    </Grid> : null}

                  {petsEntity.typicalLocation ?
                    <Grid> <label className="main-title-label"> Typical Location:</label>
                      <Grid className="container-field">
                        {<IoIosList />}<label> {petsEntity.typicalLocation}</label>
                      </Grid>
                    </Grid> : null}

                  {petsEntity.weight ?
                    <Grid> <label className="main-title-label"> Weight:</label>
                      <Grid className="container-field">
                        {<IoIosList />}<label> {petsEntity.weight}</label>
                      </Grid>
                    </Grid> : null}

                  {petsEntity.caged ?
                    <Grid> <label className="main-title-label"> Caged?:</label>
                      <Grid className="container-field">
                        {<IoMdCheckboxOutline />}<label>{renderCagedSwitch(petsEntity.caged)} </label>
                      </Grid>
                    </Grid> : null}
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Container>
    </div>
  )
}

export default PetsItem
